import {
  CampaignFillMediumIcon,
  CampaignOutlineMediumIcon,
  HomeFillMediumIcon,
  HomeOutlineMediumIcon,
  LocalActivityFillMediumIcon,
  LocalActivityOutlineMediumIcon,
  MenuBarBase,
  MenuLinkPrimary,
  ProductAngeplusFillMediumIcon,
  ProductAngeplusOutlineMediumIcon,
} from '@ferreri/prever-component-lib';
import { COMPANIES, HOME, PUBLICATIONS } from '@modules/routes/constants';
import { ReactNode } from 'react';
import { SETTINGS } from '../../config/settings';

export type ClubeMenuProps = {
  children?: ReactNode;
};

export const ClubeMenu = (props: ClubeMenuProps) => (
  <MenuBarBase subMenu={props.children}>
    <MenuLinkPrimary
      label={'Angeplus'}
      href={'/hub/home'}
      icon={<ProductAngeplusOutlineMediumIcon />}
      activeIcon={<ProductAngeplusFillMediumIcon />}
    />
    <MenuLinkPrimary
      label={'Clube'}
      href={`${SETTINGS.public.basePath}${HOME}`}
      icon={<HomeOutlineMediumIcon />}
      activeIcon={<HomeFillMediumIcon />}
    />
    <MenuLinkPrimary
      label={'Benefícios'}
      href={`${SETTINGS.public.basePath}${PUBLICATIONS}`}
      icon={<LocalActivityOutlineMediumIcon />}
      activeIcon={<LocalActivityFillMediumIcon />}
    />
    <MenuLinkPrimary
      label={'Anunciar'}
      href={`${SETTINGS.public.pathPartnerWeb}${COMPANIES}`}
      icon={<CampaignOutlineMediumIcon />}
      activeIcon={<CampaignFillMediumIcon />}
    />
  </MenuBarBase>
);
